<template>
    <DefaultHeader />
    <div :class="{ 'd-none': $store.state.hiddenBody }" class="vehicle-page-shell">
        <section class="container vehicle-page">
            <nav class="vehicle-breadcrumb" aria-label="Fil d'Ariane">
                <router-link to="/baliseslistall">Véhicules</router-link>
                <span aria-hidden="true">/</span>
                <span aria-current="page">{{ baliseInfo.name || 'Fiche véhicule' }}</span>
            </nav>

            <div class="row g-4 align-items-start vehicle-page-grid">
                <div class="col-12 col-xl-6 vehicle-main-column">
                    <div class="vehicle-summary-card">
                        <MainBaliseInfo :baliseInfo="baliseInfo" :groups="groups" @refresh="refreshData"
                            @changeBalise="changeBalise" @setBaliseToUpdate="setBaliseToUpdate" />

                        <VehicleMapIcon :balise="baliseInfo" class="d-none d-lg-block" />
                    </div>
                </div>

                <div class="col-12 col-xl-6 vehicle-side-stack">
                    <PositionShareCard v-if="baliseInfo.id && ($isOperator || $isAdmin)" :balise="baliseInfo" />

                    <VehicleBadgesCard v-if="baliseInfo.id && baliseInfo.badges?.length"
                        :badges="baliseInfo.badges" />

                    <SuperAdmin v-if="baliseInfo.id && $isAdmin" :balise="baliseInfo" />

                    <BaliseButtonsCard v-if="baliseInfo.id && $isAdmin" :buttons="baliseButtons" :balise="baliseInfo" />

                    <CorridoringControl v-if="baliseInfo.id && baliseInfo.featureCorridoring"
                        @refresh="refreshData()" :balise="baliseInfo" />

                    <DrivesAlarmsPositions :drives="baliseDrives" :alarms="baliseAlerts" :positions="balisePings" />

                    <VehicleReportCard v-if="baliseInfo.id" :balise-id="baliseInfo.id" />

                    <HistoryDatepicker :balise="baliseInfo" />
                </div>
            </div>

            <div v-if="[1, 2, 4].includes(baliseInfo.commercialPackageId)" class="vehicle-notifications">
                <NotificationParam :balise="baliseInfo" />
            </div>
        </section>
    </div>
    <IconPickerModal :baliseToUpdate="baliseToUpdate" />
    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import BaliseRepository from '@/repositories/balise.repo.js'
import FormatHelper from '@/helpers/format.helper.js'
import PositionService from '@/services/position.service'
import DriveService from '@/services/drive.service'
import AlarmService from '@/services/alarm.service'
import IconPickerModal from '@/components/balisesPage/IconPickerModal.vue'
import Group from '@/services/group.service'
import DrivesAlarmsPositions from './Sections/DrivesAlarmsPositions.vue'
import CorridoringControl from './Sections/CorridoringControl.vue'
import SuperAdmin from './Sections/SuperAdmin.vue'
import VehicleMapIcon from './Sections/VehicleMapIcon.vue'
import MainBaliseInfo from './Sections/MainBaliseInfo.vue'
import NotificationParam from './Sections/NotificationParam.vue'
import HistoryDatepicker from './Sections/HistoryDatepicker.vue'
import VehicleReportCard from './Sections/VehicleReportCard.vue'
import CmdService from '@/services/cmd.service'
import BaliseButtonsCard from './Sections/BaliseButtonsCard.vue'
import PositionShareCard from './Sections/PositionShareCard.vue'
import VehicleBadgesCard from './Sections/VehicleBadgesCard.vue'

export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        IconPickerModal,
        DrivesAlarmsPositions,
        CorridoringControl,
        VehicleMapIcon,
        MainBaliseInfo,
        NotificationParam,
        HistoryDatepicker,
        SuperAdmin,
        VehicleReportCard,
        BaliseButtonsCard,
        PositionShareCard,
        VehicleBadgesCard
    },
    data() {
        return {
            baliseInfo: {},
            balisePings: [],
            baliseDrives: [],
            baliseAlerts: [],
            baliseToUpdate: null,
            groups: [],
            baliseButtons: [],
        };
    },
    mounted() {
        this.refreshData();
        this.baliseLastsPings();
        this.baliseLastsDrives();
        this.baliseLastsAlerts();
        this.getAllGroups();
        this.loadBaliseButtons();
    },
    methods: {

        /************************************************/
        /**** START DISPLAYED INFO LOADING FUNCTIONS ****/
        /************************************************/

        // Get the balise data
        refreshData() {
            BaliseRepository.getBalise(this.$route.params.id)
                .then(balise => {
                    this.baliseInfo = balise;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        // Get the 3 last positions to be displayed in the positions area
        baliseLastsPings() {
            PositionService.getBalisePositions(this.$route.params.id, 0, 3)
                .then(response => {
                    this.balisePings = FormatHelper.balisePingsFormat(response.data)
                })
        },
        // Get the 3 last drives to be displayed in the drives area
        baliseLastsDrives() {
            DriveService.getBaliseDrives(this.$route.params.id, 0, 3)
                .then(response => {
                    this.baliseDrives = FormatHelper.baliseDrivesFormat(response.data.rows)
                })
        },
        // Get the 3 last alerts to be displayed in the alerts area
        baliseLastsAlerts() {
            AlarmService.getBaliseAlarms(this.$route.params.id, 0, 3)
                .then(response => {
                    this.baliseAlerts = FormatHelper.baliseAlertsFormat(response.data.rows)
                })
        },

        /**********************************************/
        /**** END DISPLAYED INFO LOADING FUNCTIONS ****/
        /**********************************************/

        setBaliseToUpdate(param) {
            this.baliseToUpdate = param;
        },
        changeBalise(bId) {
            this.$emit("param", bId);
        },
        getAllGroups() {
            Group.getClientGroups().then(groups => {
                for (let group in groups.data) {
                    this.groups.push([groups.data[group].name, groups.data[group]])
                }
            })
        },
        loadBaliseButtons() {
            if (!this.$route.params.id) return;
            CmdService.getButtons(this.$route.params.id)
                .then(response => {
                    // on suppose que l'API renvoie un tableau direct
                    this.baliseButtons = Array.isArray(response.data) ? response.data : [];
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }
}
</script>

<style>
/* Habillage limité à la fiche véhicule : pas d'impact sur les autres pages. */
.vehicle-page-shell {
    min-height: calc(100vh - 140px);
    padding: 1.45rem 0 3.5rem;
    background: #f5f7fb;
    color: #1d2c43;
}

.vehicle-page {
    max-width: 1450px;
    min-width: 0;
}

.vehicle-breadcrumb {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin: 0 0 24px;
    padding: 0 0.2rem;
    color: #8a97aa;
    font-size: 13px;
}

.vehicle-breadcrumb a {
    color: #315c94;
    font-weight: 700;
    text-decoration: none;
}

.vehicle-breadcrumb a:hover {
    text-decoration: underline;
}

.vehicle-breadcrumb span[aria-current] {
    min-width: 0;
    overflow-wrap: anywhere;
    color: #5f6f86;
}

.vehicle-page-grid > *,
.vehicle-main-column,
.vehicle-side-stack {
    min-width: 0;
}

.vehicle-side-stack {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
}

.vehicle-side-stack > * {
    width: 100%;
    min-width: 0;
}

.vehicle-page .card {
    min-width: 0;
    border: 1px solid #e5eaf1;
    border-radius: 17px;
    background: #fff;
    box-shadow: 0 6px 24px rgba(26, 43, 68, 0.055);
}

.vehicle-page .card.rounded {
    border-radius: 17px !important;
}

.vehicle-page .card.shadow,
.vehicle-page .card.shadow-sm {
    box-shadow: 0 6px 24px rgba(26, 43, 68, 0.055) !important;
}

.vehicle-page .card > .card-header {
    margin: 0;
    padding: 1rem 1.2rem;
    border-bottom: 1px solid #e9eef5;
    border-radius: 16px 16px 0 0;
    background: linear-gradient(105deg, #fff 45%, #f7faff 100%);
    color: #22334e;
    font-size: 0.99rem;
    font-weight: 700;
    line-height: 1.4;
}

.vehicle-page .card > .card-footer {
    border-top: 1px solid #edf0f5;
    border-radius: 0 0 16px 16px;
    background: #fbfcfe;
    color: #8793a5;
    font-size: 0.8rem;
}

.vehicle-page .card-footer a {
    color: #2866b8;
    font-weight: 650;
    text-decoration: none;
}

.vehicle-page .card-footer a:hover,
.vehicle-page a:not(.btn):hover {
    color: #194f98;
}

.vehicle-page .btn {
    border-radius: 10px;
    font-weight: 600;
    transition: background-color 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.vehicle-page .btn-primary {
    border-color: #2e68be;
    background: #2e68be;
}

.vehicle-page .btn-primary:hover:not(:disabled) {
    border-color: #2457a4;
    background: #2457a4;
}

.vehicle-page .btn-outline-primary {
    border-color: #c8daf3;
    background: #f7faff;
    color: #2e65ae;
}

.vehicle-page .btn-outline-primary:hover:not(:disabled) {
    border-color: #2e68be;
    background: #2e68be;
    color: #fff;
}

.vehicle-page .form-control,
.vehicle-page .form-select {
    border-color: #dce5f1;
    border-radius: 9px;
    color: #23344e;
}

.vehicle-page .form-control:focus,
.vehicle-page .form-select:focus {
    border-color: #7ba8e5;
    box-shadow: 0 0 0 3px rgba(60, 121, 205, 0.12);
}

/* Historique : onglets en commandes segmentées, tableaux aérés. */
.vehicle-page .nav.nav-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem;
    width: max-content;
    max-width: 100%;
    padding: 0.35rem;
    margin: 0 0 0.55rem;
    border: 1px solid #e4ebf5 !important;
    border-radius: 13px !important;
    background: #ecf1f8 !important;
}

.vehicle-page .nav-tabs .nav-link {
    padding: 0.5rem 0.95rem;
    border: 0;
    border-radius: 9px;
    background: transparent;
    color: #60728a;
    font-size: 0.82rem;
    font-weight: 650;
    text-decoration: none !important;
    transition: background-color 0.15s, color 0.15s;
}

.vehicle-page .nav-tabs .nav-link.active {
    border: 0;
    background: #fff;
    color: #255ca7;
    box-shadow: 0 2px 7px rgba(38, 61, 91, 0.11);
}

.vehicle-page .nav-tabs .nav-link:hover:not(.active) {
    background: #e0e8f3;
    color: #314e73;
}

.vehicle-page .table-responsive {
    padding: 1rem 1.1rem !important;
}

.vehicle-page .table {
    margin-bottom: 0;
    color: #263b59;
    font-size: 0.82rem;
}

.vehicle-page .table thead th {
    padding: 0.65rem 0.7rem;
    border-bottom: 1px solid #e6ecf3;
    color: #78879a;
    font-size: 0.71rem;
    font-weight: 730;
    letter-spacing: 0.035em;
    text-transform: uppercase;
}

.vehicle-page .table tbody td {
    padding: 0.75rem 0.7rem;
    border-bottom-color: #edf1f6;
    color: #4c5e75;
    vertical-align: middle;
}

.vehicle-page .table tbody tr:last-child td {
    border-bottom: 0;
}

/* La fiche et la carte forment un seul bloc, sans bordures internes arrondies. */
.vehicle-summary-card {
    overflow: hidden;
    border: 1px solid #e5eaf1;
    border-radius: 17px;
    background: #fff;
    box-shadow: 0 6px 24px rgba(26, 43, 68, 0.055);
}

.vehicle-page .vehicle-summary-card > .card {
    margin: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}

.vehicle-page .vehicle-summary-card > .card + .card {
    border-top: 1px solid #e9eef5 !important;
}

.vehicle-page .vehicle-summary-card > .card .card-footer {
    padding: 0.8rem 1rem !important;
}

.vehicle-page .position-share-card {
    overflow: hidden;
}

.vehicle-page .position-share-create-button {
    min-height: 33px;
}

.vehicle-page .vehicle-badges-card {
    box-shadow: 0 6px 24px rgba(26, 43, 68, 0.055);
}

.vehicle-page .vehicle-badges-header {
    background: linear-gradient(105deg, #fff 45%, #f7faff 100%);
}

/* Les cartes de notifications ne reprennent pas les ombres Bootstrap fortes. */
.vehicle-notifications {
    margin-top: 1.4rem;
}

.vehicle-notifications > .card,
.vehicle-notifications > * > .card {
    padding: 1.3rem !important;
}

.vehicle-notifications .list-group-item {
    border-color: #edf0f5;
    color: #526278;
    font-size: 0.83rem;
}

.vehicle-page .input-group-text {
    border-color: #dce5f1;
    background: #f2f6fb;
    color: #58708c;
}

.vehicle-page .pointer-cursor:hover {
    cursor: pointer;
}

@media (max-width: 767.98px) {
    .vehicle-page-shell {
        padding: 1.1rem 0 2.2rem;
    }

    .vehicle-breadcrumb {
        margin-bottom: 1.15rem;
    }

    .vehicle-page-grid {
        --bs-gutter-y: 1rem;
    }

    .vehicle-side-stack {
        gap: 1rem;
    }

    .vehicle-page .card > .card-header {
        padding: 0.85rem 1rem;
    }

    .vehicle-page .table-responsive {
        padding: 0.75rem !important;
    }
}

@media (max-width: 575.98px) {
    .vehicle-page .nav-tabs .nav-link {
        padding: 0.5rem 0.65rem;
        font-size: 0.76rem;
    }

    .vehicle-page .position-share-header {
        gap: 0.65rem;
    }

    .vehicle-notifications > .card,
    .vehicle-notifications > * > .card {
        padding: 0.85rem !important;
    }
}
</style>
